import { useCallback, useRef } from "react";

export const useThrottle = (fn: () => void, delay: number) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  return useCallback(() => {
    if (timeoutRef.current) return;
    timeoutRef.current = setTimeout(() => {
      fn();
      timeoutRef.current = null;
    }, delay);
  }, [fn, delay]);
};
